<template>
  <footer class="mt-40 border-t border-white/10 bg-black/60 backdrop-blur-3xl pt-20 pb-10 px-4">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
        <div class="col-span-2">
          <h2 class="text-3xl font-black gradient-text mb-6">AUTHENTIQUE ARTIFICE</h2>
          <p class="text-gray-400 max-w-md text-lg leading-relaxed">
            Votre partenaire premium pour tous vos événements pyrotechniques. Mariages, anniversaires, fêtes nationales. Le spectacle commence ici.
          </p>
          <div class="mt-8 flex gap-6 grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all cursor-pointer">
            <img src="/img/payment/visa.svg" alt="Paiement sécurisé par Visa" width="48" height="32" class="h-8 w-auto" />
            <img src="/img/payment/mastercard.svg" alt="Paiement sécurisé par Mastercard" width="48" height="32" class="h-8 w-auto" />
            <img src="/img/payment/paypal.svg" alt="Paiement sécurisé par PayPal" width="96" height="32" class="h-8 w-auto" />
          </div>
        </div>
        
        <div>
          <h3 class="font-black mb-6 uppercase tracking-widest text-fire-gold">EXPLORER</h3>
          <ul class="space-y-4 text-gray-400 font-bold">
            <li><router-link to="/" class="hover:text-white transition-all">BOUTIQUE</router-link></li>
            <li><router-link to="/categorie/packs" class="hover:text-white transition-all">NOS PACKS</router-link></li>
            <li><router-link to="/conseils-expert" class="hover:text-white transition-all">NOS CONSEILS</router-link></li>
            <li><router-link to="/admin" class="hover:text-white transition-all italic text-xs text-gray-300">ADMINISTRATION</router-link></li>
          </ul>
        </div>

        <div>
           <h3 class="font-black mb-6 uppercase tracking-widest text-fire-gold">CONSEILS</h3>
           <ul class="space-y-4 text-gray-400 font-bold">
             <li><router-link to="/blog/securiser-premier-spectacle-pyrotechnique-guide" class="hover:text-white transition-all">SÉCURITÉ</router-link></li>
             <li><router-link to="/blog/reglementation-feux-artifice-f1-f2-f3" class="hover:text-white transition-all">RÉGLEMENTATION</router-link></li>
             <li><router-link to="/blog/organiser-feu-artifice-mariage-guide" class="hover:text-white transition-all">MARIAGE</router-link></li>
             <li><router-link to="/blog/reussir-14-juillet-spectacle-petit-budget" class="hover:text-white transition-all">14 JUILLET</router-link></li>
           </ul>
        </div>
        
        <div>
          <h3 class="font-black mb-6 uppercase tracking-widest text-fire-gold">CONTACT</h3>
          <ul class="space-y-4 text-gray-400 font-bold px-2">
            <li class="flex items-center gap-3">
               <div class="p-1 rounded bg-fire-gold/10 text-fire-gold"><i class="fa fa-map-marker"></i></div>
               <span class="text-xs">75000 PARIS, FRANCE</span>
            </li>
            <li class="flex items-center gap-3">
               <div class="p-1 rounded bg-fire-gold/10 text-fire-gold"><i class="fa fa-phone"></i></div>
               <span class="text-xs">06 12 34 56 78</span>
            </li>
            <li class="flex items-center gap-3">
               <div class="p-1 rounded bg-white/5 text-white"><i class="fa fa-envelope"></i></div>
               <span class="text-xs">contact@authentiqueartifice.fr</span>
            </li>
            <li class="flex gap-4 pt-4">
              <div class="p-2 border border-white/10 rounded-full hover:border-fire-gold transition-all cursor-pointer">
                <i class="fa fa-instagram text-fire-gold"></i>
              </div>
              <div class="p-2 border border-white/10 rounded-full hover:border-fire-gold transition-all cursor-pointer">
                <i class="fa fa-facebook text-fire-gold"></i>
              </div>
            </li>
          </ul>
        </div>
      </div>
      
      <div class="border-t border-white/5 pt-10 text-center flex flex-col md:flex-row justify-between items-center text-sm font-bold text-gray-300 gap-4">
        <p>© 2026 AUTHENTIQUE ARTIFICE - TOUS DROITS RÉSERVÉS</p>
        <div class="flex gap-8">
          <router-link to="/mentions-legales" class="hover:text-white transition-all text-gray-300">MENTIONS LÉGALES</router-link>
          <router-link to="/conditions-generales" class="hover:text-white transition-all text-gray-300 uppercase">CGV</router-link>
          <router-link to="/politique-de-confidentialite" class="hover:text-white transition-all text-gray-300 uppercase">Confidentialité</router-link>
          <router-link to="/politique-cookies" class="hover:text-white transition-all text-gray-300 uppercase">Cookies</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
</script>
